import { defineStore } from "pinia";
import _ from "lodash";

export const useGlobalStore = defineStore("global", {
	state: () => {
		return {
			mobile: false,
			cart: false,
			search: false,
			announcementBarVisible: true,
			pointerFine: window.matchMedia("(pointer: fine)").matches,
			modal: {
				name: null,
				payload: null,
			},
		};
	},
	getters: {
		hasActiveOverlay() {
			return this.mobile || this.cart || this.modal.name !== null;
		},
	},
	actions: {
		updateBodyOverflow() {
			if (this.hasActiveOverlay) {
				document.body.classList.add("overflow-hidden");
			} else {
				document.body.classList.remove("overflow-hidden");
			}
		},
		toggleMobile(delta) {
			delta != null ? (this.mobile = delta) : (this.mobile = !this.mobile);
			if (this.mobile) {
				this.toggleCart(false);
				this.toggleSearch(false);
			}
			this.updateBodyOverflow();
		},
		toggleCart(delta) {
			delta != null ? (this.cart = delta) : (this.cart = !this.cart);
			if (this.cart) {
				this.toggleMobile(false);
				this.toggleSearch(false);
			}
			this.updateBodyOverflow();
		},
		toggleSearch(delta) {
			delta != null ? (this.search = delta) : (this.search = !this.search);
			if (this.search) {
				this.toggleMobile(false);
				this.toggleCart(false);
			}
		},
		setTheme(background, accent, surface) {
			if (background !== null && accent !== null && surface !== null) {
				document.documentElement.style.setProperty(
					"--theme-background",
					background,
				);
				document.documentElement.style.setProperty(
					"--theme-accent",
					accent,
				);
				document.documentElement.style.setProperty(
					"--theme-surface",
					surface,
				);
			} else {
				document.documentElement.style.setProperty(
					"--theme-background",
					"#F7F7F7",
				);
				document.documentElement.style.setProperty(
					"--theme-accent",
					"#151515",
				);
				document.documentElement.style.setProperty(
					"--theme-surface",
					"#151515",
				);
			}
		},
		setHeaderTheme(background, accent, surface) {
			const header = document.querySelector("header");
			if (!header) return;
			if (background !== null && accent !== null && surface !== null) {
				header.style.setProperty("--theme-background", background);
				header.style.setProperty("--theme-accent", accent);
				header.style.setProperty("--theme-surface", surface);
			} else {
				header.style.removeProperty("--theme-background");
				header.style.removeProperty("--theme-accent");
				header.style.removeProperty("--theme-surface");
			}
		},
		setup() {
			//
		},
		openModal(modal) {
			this.modal = {
				name: modal,
				payload: null,
			};
			this.updateBodyOverflow();
		},
		setModal(modal) {
			this.modal = {
				name: modal[0],
				payload: modal[1],
			};
			this.updateBodyOverflow();
		},
		closeModal() {
			this.modal = {
				name: null,
				payload: null,
			};
			this.updateBodyOverflow();
		},
		setAnnouncementBarVisible(visible) {
			this.announcementBarVisible = visible;
		},
	},
});
